import React from 'react';
import UsaStates from 'usa-states';

export const StateSelect = ({ id, value, onChange, required = false, disabled = false }) => {
    const usaStates = new UsaStates.UsaStates();

    return (
        <select
            id={`${id}`}
            onChange={onChange}
            value={value}
            required={required}
            disabled={disabled}
        >
            <option value=''>Select</option>
            {usaStates.states.map((state) => {
                return (
                    <option
                        key={state.name}
                        value={state.abbreviation}
                    >
                        {state.name}
                    </option>
                );
            })}
        </select>
    );
};
